import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';
import { Button } from '@/shared/ui/button';
import { useAuth } from '@/core/auth/useAuth';
import { KeyRound, LogOut, ChevronDown } from 'lucide-react';
import { ChangePasswordDialog } from './ChangePasswordDialog';

interface UserMenuProps {
  userName: string;
}

export const UserMenu: React.FC<UserMenuProps> = ({ userName }) => {
  const { signOut } = useAuth();
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="flex items-center gap-1 min-h-[44px] px-3 font-medium text-foreground/80 hover:text-foreground hover:bg-accent"
          >
            <span className="text-sm">{userName}</span>
            <ChevronDown className="h-4 w-4 opacity-50" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem
            onClick={() => setShowChangePassword(true)}
            className="cursor-pointer"
          >
            <KeyRound className="mr-2 h-4 w-4" />
            Cambia Password
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={signOut}
            className="cursor-pointer text-red-600 focus:text-red-600 focus:bg-red-50"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ChangePasswordDialog
        open={showChangePassword}
        onOpenChange={setShowChangePassword}
      />
    </>
  );
};

export default UserMenu;
